/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusUserSearchVo } from './BonusUserSearchVo';
import {
    BonusUserSearchVoFromJSON,
    BonusUserSearchVoFromJSONTyped,
    BonusUserSearchVoToJSON,
    BonusUserSearchVoToJSONTyped,
} from './BonusUserSearchVo';

/**
 * 
 * @export
 * @interface ResponseListBonusUserSearchVo
 */
export interface ResponseListBonusUserSearchVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListBonusUserSearchVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListBonusUserSearchVo
     */
    message?: string;
    /**
     * 
     * @type {Array<BonusUserSearchVo>}
     * @memberof ResponseListBonusUserSearchVo
     */
    data?: Array<BonusUserSearchVo>;
}

/**
 * Check if a given object implements the ResponseListBonusUserSearchVo interface.
 */
export function instanceOfResponseListBonusUserSearchVo(value: object): value is ResponseListBonusUserSearchVo {
    return true;
}

export function ResponseListBonusUserSearchVoFromJSON(json: any): ResponseListBonusUserSearchVo {
    return ResponseListBonusUserSearchVoFromJSONTyped(json, false);
}

export function ResponseListBonusUserSearchVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListBonusUserSearchVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(BonusUserSearchVoFromJSON)),
    };
}

export function ResponseListBonusUserSearchVoToJSON(json: any): ResponseListBonusUserSearchVo {
    return ResponseListBonusUserSearchVoToJSONTyped(json, false);
}

export function ResponseListBonusUserSearchVoToJSONTyped(value?: ResponseListBonusUserSearchVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(BonusUserSearchVoToJSON)),
    };
}

